export const version = '0.798.0'
export const chameleonWebVersion = '9.19.4'
export const chameleonCoreVersion = '7.12.1'
